import Btn from '@components/UI/Btn';
import { colors } from '@styles/vars';
import React from 'react';

const SubmitButtonWidget = ({width, text = 'Save', ...props }) => {
  return <Btn text={text} color={colors.success} type="submit" {...props} style={{width: width ? width : null}} />;
};

export default SubmitButtonWidget;
